import {Visibility, VisibilityOff} from "@mui/icons-material";
import {IconButton, InputAdornment, Link, Typography} from "@mui/material";
import axios from "axios";
import React, {useState} from "react";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {sleep} from "../../util/Sleep";
import * as validators from "../../util/Validators";
import CCButton from "../Common/CCButton";
import CCInputLabel from "../Common/CCInputLabel";
import CCTextField from "../Common/CCTextField";
import css_shared from "./css/LoginCommon.module.scss";
import css_self from "./css/LoginHelp3.module.scss";
import {useLoginHelpContext} from "./LoginHelp";

export default function LoginHelp3() {

    const [submitting, setSubmitting] = useState(false);
    const [errorText, setErrorText] = useState(undefined);
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const {helpState} = useLoginHelpContext();

    const navigate = useNavigate();

    async function submit() {

        const startAt = Date.now();

        setSubmitting(true);

        const response = await axios({
            method: "POST",
            baseURL: process.env.REACT_APP_API_URL,
            url: "s6/v1/forgot_password",
            json: true,
            data: {
                NewPassword: password,
                Key: helpState.key,
                Code: helpState.code,
            },
        }).catch(e => e.response || e);

        if (response instanceof Error && response.message === "Network Error") {
            setSubmitting(false);
            setErrorText("Connection not available");
            return;
        }

        const waitDiff = 2000 - (Date.now() - startAt);
        waitDiff > 0 && (await sleep(waitDiff));

        if (response.status !== 204) {
            setSubmitting(false);
            setErrorText("Service temporarily unavailable");
            return;
        }

        navigate("/", {replace: true});
    }

    function validate() {

        setErrorText(undefined);

        if (!validators.Required(password)) {
            setErrorText("Password must contain a value.");
        } else if (!validators.Minimum(password, 8)) {
            setErrorText("Password must have at least 8 characters.");
        } else if (!validators.NoSpaces(password)) {
            setErrorText("Password must have no spaces.");
        } else if (!validators.MatchValues(password, passwordConfirm)) {
            setErrorText("Passwords must match.");
        } else {
            return true;
        }

        return false;
    }

    return (
        <form onSubmit={e => e.preventDefault()}>
            <Typography className={css_shared.Title}>Reset your password</Typography>
            <CCInputLabel>New password</CCInputLabel>
            <CCTextField
                value={password}
                placeholder="Enter new password"
                type={showPassword ? "text" : "password"}
                onChange={async e => setPassword(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={async () => setShowPassword(!showPassword)}
                                onMouseDown={e => e.preventDefault()}
                                size="large"
                            >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <CCInputLabel>Confirm new password</CCInputLabel>
            <CCTextField
                value={passwordConfirm}
                placeholder="Reenter new password"
                type={showPassword ? "text" : "password"}
                onChange={async e => setPasswordConfirm(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={async () => setShowPassword(!showPassword)}
                                onMouseDown={e => e.preventDefault()}
                                size="large"
                            >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                helperText={<span className="Mui-error" style={{visibility: errorText ? undefined : "hidden"}}>{errorText}</span>}
            />
            <CCButton
                className={css_self.Button}
                margin="none"
                animate={submitting}
                disabled={submitting}
                onClick={() => {
                    if (validate()) {
                        submit();
                    }
                }}
            >
                Reset Password
            </CCButton>
            <Typography className={css_shared.LoginInsteadText}>
                Already have an account?{" "}
                <Link component={RouterLink} to="/" replace={true}>Login</Link>
            </Typography>
        </form>
    );
}
